import React, { useState, useEffect, useRef } from 'react';
import  { Container, Row, Col, Button, Modal, Form, Table, Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import moment from 'moment';
import { InforAlert, getRoles } from '../../utils/swtAlert';
import { Decrypt } from '../../utils/Helper';
import { GrokLoading } from "../page-layout/loading/Loading";
import { GetChallengeParticipants, GetChallengeReport } from "../../utils/axios/ReportsAPI";

const GroupByChallenge = () => {
    const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [clearRows, setClearRows] = useState(false);
    const [role, setRole] = useState('');
    const [filteredData, setFilteredData] = useState('');
        
    const filterRef = useRef();
    const StudentTable = useRef();

    const columns = [
        {
          name: "Use case Title",
          selector:  row => row.challengeName,
          sortable:true,
          cell: row => row.challengeName,
        },
        {
          name: "Industry Partner",
          selector:  row => row.companyName,
          sortable:true,
          cell: row => row.companyName,
        },
        {
          name: "Total Colleges Participated",
          selector: row => row.organizationCount,
          sortable: true,
          cell: row => row.organizationCount,
          omit: (role !== 'Grok Admin') ? true :false
        },
        {
          name: "Total Students Participated",
          selector: row => row.StudentCount,
          sortable: true,
          cell: row => row.StudentCount,
          omit: (role !== 'Grok Admin') ? true :false
        },
        {
          name: "Notification Status", // Notification Status
          width: "180px",
          selector: row => row.NotificationStatus == 1 ? "Published" : "UnPublished",
          sortable: true,
          cell: row => row.NotificationStatus == 1 ? "Published" : "UnPublished",
          conditionalCellStyles: [
                {
                    when: row => row.NotificationStatus == 1,
                    style: {
                        color: 'green',
                    },
                },
                {
                    when: row => row.NotificationStatus == 0,
                    style: {
                        color: 'red',
                    },
                },
            ],
        },
        {
            name: "Participation",
            width: "150px",
            cell: (row) => (<>
                <button className="btn btn-link" title="Participant Details" disabled={row.organizationCount == 0 ? true : false} onClick={() => handleShowParticipants(row.challengeName,row.companyName, row)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><circle cx="152" cy="184" r="72"></circle><path d="M234 296c-28.16-14.3-59.24-20-82-20-44.58 0-136 27.34-136 82v42h150v-16.07c0-19 8-38.05 22-53.93 11.17-12.68 26.81-24.45 46-34z"></path><path d="M340 288c-52.07 0-156 32.16-156 96v48h312v-48c0-63.84-103.93-96-156-96z"></path><circle cx="340" cy="168" r="88"></circle></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },
    ]
    const [data, setData] = useState();
    const tableData = {
        print:false,
        export:false,
      columns,
      data,
    };

    const BackBtn = () => {
        navigate('/home');
    }

    const addRefresh = () => {
        navigate('/home', {state: {companyid: null}});
    }

    const [showParticipants, setShowParticipants] = useState(false);
    const handleCloseParticipants = () => setShowParticipants(false);
    const handleShowParticipants = async (title, orgName, organizations) => {
        if(organizations.organizationCount !== 0){

            let participantsPayload = {
                challengeId: organizations.ChallengeId
            }
            setLoading(true);
            var participantsResponse = await GetChallengeParticipants(participantsPayload);
            setLoading(false);

            setShowParticipants(true);
            const tableRows = [];
    
            participantsResponse.organizations.forEach((org) => {
                const  clg  = org;
                const  student  = org.students;
                            
                tableRows.push(`<tr><td class='text-nowrap' rowSpan="${student.length + 1}"><h5>${clg.organizationName}</h5></td></tr>`);
                
                student.forEach((student) => {
                    tableRows.push(`<tr>
                                        <td  class='text-nowrap '>${student.DisplayName}</td>
                                        <td  class='text-nowrap '>${student.Email}</td>
                                        <td  class='text-nowrap '>${student.Branch.Name}</td>
                                        <td  class='text-nowrap '>${student.Year.Name}</td>
                                        <td  class='text-nowrap '>${student.Semester.Name}</td>
                                    </tr>`);
                })
            });
                           
            setTimeout(() => {
                document.getElementById('ChallengeTitle').innerText = title;
                if (role !== "Company") {
                    document.getElementById('ChallengeOrgName').innerText = orgName;
                }
                StudentTable.current.innerHTML = tableRows.join(' ');
            }, 10);
        }
        else if(organizations.organizationCount === 0){
            InforAlert("warning", 'There is no participants in this challenge', 'warning', 'OK')
            setShowParticipants(false);
        }
    }

    const getchallengesreport = async () => {
        var organizationResponse = await GetChallengeReport();
        setData(organizationResponse.data);
        setFilteredData(organizationResponse.data);
        setLoading(false);
        setClearRows(false);
    }

    useEffect(() => {
        getchallengesreport();
        const role = getRoles(userInfo);
        setRole(role);
        setTimeout(() => {
            if(role === 'Grok Admin') { //Grok Admin
                document.getElementById('nav-dropdownReport').parentElement.classList.add('show');
                document.getElementById('nav-dropdownReport').nextSibling.classList.add('show');
            }
            else {
                // Error handler
            }
            
        }, 300);
    }, [])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home</Breadcrumb.Item>
                                    <Breadcrumb.Item active> Group By Industry Use Case</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Challenge'>
                                    <span><svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M9 1H1V9H9V6H11V20H15V23H23V15H15V18H13V6H15V9H23V1H15V4H9V1ZM21 3H17V7H21V3ZM17 17H21V21H17V17Z" fill="currentColor"></path></svg></span>
                                </Button>
                                <h2 className="page-title">Group By Industry Use Case</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3 mt-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                      noDataComponent={(role === 'Grok Admin') ? 
                                        (<span className='my-4'>Please select Notification status</span>):
                                        (<span className='my-2'>There are no records to display</span>)}
                                      clearSelectedRows={clearRows}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                    
                    <div>
                        <Modal show={showParticipants} onHide={handleCloseParticipants} size="xl" backdrop="static" keyboard={false} className="model-popup" dialogClassName="modal-90w modal_report" centered>
                        {loading ? <GrokLoading /> : ""}
                        <Modal.Header closeButton>
                            <Modal.Title id="example-custom-modal-styling-title"><b>Group By Challenges</b> </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className='challenge_detail_style mb-3 d-flex bold'>
                                <h5 id='ChallengeTitle' className='mx-2 mt-1'></h5>{role !== "Company" && `-`}
                                {role !== "Company" && <h5 id='ChallengeOrgName' className='mx-2 mt-1'></h5>}
                            </div>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive>
                                    <thead className='fw-bold'>
                                        <tr>
                                            <th>College Name</th>
                                            <th>Student Name</th>
                                            <th>Email</th>
                                            <th>Branch</th>
                                            <th>Year</th>
                                            <th>Semester</th>
                                        </tr>
                                    </thead>
                                    <tbody ref={StudentTable}></tbody>
                                </Table>
                            </div>
                        </Modal.Body>
                        </Modal>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default GroupByChallenge; 